import React from "react";
import { Button, FilterBar, SearchBar } from "@sscs/ui";
import { AllowedTo } from "Components";
import { PERMISSION } from "Constants";
import AddGroupIcon from "../../assets/ButtonAddGroupIcon.svg";
import { FilterGroups } from "../../types";
import styles from "./groupsTableActionBar.module.scss";

type GroupsTableActionBarProps = {
  filter: FilterGroups;
  onFilterChange: (filter: FilterGroups) => void;
  onAddGroup: () => void;
};

const GroupsTableActionBar = ({
  filter,
  onFilterChange,
  onAddGroup,
}: GroupsTableActionBarProps): React.JSX.Element => {
  return (
    <FilterBar
      filters={[
        {
          id: "group-name",
          control: (
            <SearchBar
              id="groups-filter-name"
              value={filter.groupName ?? ""}
              onChange={(value) =>
                onFilterChange({ ...filter, groupName: value })
              }
              variant="outlined"
              label="Search for group name"
              slotProps={{ htmlInput: { maxLength: 256 } }}
              debounceTimer={250}
              isFullWidth={false}
            />
          ),
        },
        {
          id: "add-group",
          fit: true,
          control: (
            <AllowedTo permissions={[PERMISSION.CREATE_GROUP]}>
              <Button
                color="primary"
                className={styles["add-group"]}
                onClick={onAddGroup}
              >
                <AddGroupIcon className={styles.icon} />
                Create group
              </Button>
            </AllowedTo>
          ),
        },
      ]}
    />
  );
};

export default GroupsTableActionBar;
